import React from 'react'
import styled from 'styled-components'

import CheckboxArrowImg from '../../images/checkboxArrow.svg'

type Props = {
  checked: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
}

export const Checkbox: React.FC<Props> = props => (
  <CheckboxLabel>
    <input type="checkbox" {...props} />
    <CheckboxInner>
      <CheckboxArrow src={CheckboxArrowImg} />
    </CheckboxInner>
  </CheckboxLabel>
)

const CheckboxInner = styled.span`
  cursor: pointer;
  display: flex;
  height: 18px;
  width: 18px;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #8b8b8b;
  border-radius: 4px;
  > svg {
    visibility: hidden;
    position: absolute;
    left: 4px;
    top: 6px;
  }
`

const CheckboxArrow = styled.img`
  width: 12px;
  height: 8px;
  margin: auto;
`

const CheckboxLabel = styled.label`
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
  > input {
    display: none;
  }
  > input:checked {
    & + span {
      background-color: #20aee5;
      border: 1px solid #20aee5;
      svg {
        visibility: visible;
      }
    }
  }
  > input:disabled {
    & + span {
      cursor: default;
      opacity: 0.3;
    }
  }
`
